import React from 'react';
import { withStyles, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, withRouter } from '../../../material-ui';
import IndexUtil from '../../../model/IndexUtil';

class MovieIndexRaqiu extends React.Component {

    constructor(props) {
        super(props);
        // let data = this.getSourceData(props.data);
        // this.state = { data: data }
    }

    // getSourceData(data) {
    //     if (!data) return [];
    //     let sdata = [];
    //     data.forEach(element => {
    //         if (!sdata[element.company_id]) {
    //             sdata[element.company_id] = [];
    //         }
    //         sdata[element.company_id].push(element);
    //     });
    //     return sdata;
    // } 
    // getasia = (item, i) => {
    //     if (!item) return '';
    //     if (!item.asia || item.asia.length < 3) return '';
    //     if (!item.asia[2]) return '';
    //     let asia = item.asia[2].split(',');
    //     if (asia.length <= i) return '';
    //     return asia[i];
    // }
    // getCompanyName(item) {
    //     return item ? IndexData.getCompanyName(item.company_id) : '';
    // }

    render() {
        const { classes, data } = this.props;
        let datas = IndexUtil.handleIndex(data);
        let shenpan = IndexUtil.jqsjp(2, 1, datas, function (a, b) {
            if (a == '' || b == '') {
                return false;
            }
            return b > a;
        });
        let jp = IndexUtil.jqsjp(2, 1, datas, function (a, b) {
            if (a == '' || b == '') {
                return false;
            }
            return b < a;
        });
        let gs = IndexUtil.jqgs(datas);
        let ds = IndexUtil.jqds(datas);

        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                    <Grid container direction='row' justifyContent='space-between' style={{ maxWidth: '40%' }}>
                        <Grid container direction='row' justifyContent='space-between' style={{ flex: 1 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 9, maxWidth: 30, marginLeft: 16 }}>升盘</Typography>
                            <Typography style={{ color: '#FC2E34', fontSize: 9, flex: 1, marginLeft: 8 }}>{shenpan}</Typography>
                        </Grid>
                        <Grid container direction='row' justifyContent='space-between' style={{ flex: 1 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 9, maxWidth: 30, marginLeft: 16 }}>降盘</Typography>
                            <Typography style={{ color: '#7CDF6A', fontSize: 9, flex: 1, marginLeft: 8 }}>{jp}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' justifyContent='space-between' style={{ maxWidth: '40%' }}>
                        <Grid container direction='row' justifyContent='space-between' style={{ flex: 1 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 9, maxWidth: 30 }}>高水</Typography>
                            <Typography style={{ color: '#FC2E34', fontSize: 9, flex: 1, marginLeft: 8 }}>{gs}</Typography>
                        </Grid>
                        <Grid container direction='row' justifyContent='flex-end' style={{ flex: 1 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 9, maxWidth: 30, marginRight: 8 }}>低水</Typography>
                            <Typography style={{ color: '#7CDF6A', fontSize: 9, flex: 1, marginRight: 8 }}>{ds}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid style={{ paddingLeft: 8, paddingRight: 8, width: 'calc(100% - 16px)', marginTop: 8 }}>
                    <Table style={{ width: '100%' }}>
                        <TableHead style={{ backgroundColor: '#E9F9FF' }}>
                            <TableRow>
                                <TableCell align='center' className={classes.tableHead}>盘口来源</TableCell>
                                <TableCell align='center' className={classes.tableHead}>初始盘口</TableCell>
                                <TableCell align='center' className={classes.tableHead}>即时盘口</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                datas.map((item, i) => (
                                    <TableRow key={i} style={{ backgroundColor: '#FFF' }}>
                                        <TableCell align='center' className={classes.tableBody}>{item.getName()}</TableCell>
                                        <TableCell align='center' className={classes.tableBody}>
                                            <font>
                                                <font style={{ marginRight: 8, color: '#0D0D0D', fontSize: 11 }}>{item.getInitAsia(0)}</font>
                                                <font style={{ color: '#878787', fontSize: 11 }}>{item.getInitAsia(1)}</font>
                                                <font style={{ marginLeft: 8, color: '#0D0D0D', fontSize: 11 }}>{item.getInitAsia(2)}</font>
                                            </font>
                                        </TableCell>
                                        <TableCell align='center' className={classes.tableBody}>
                                            <font>
                                                <font style={{ marginRight: 8, color: '#0D0D0D', fontSize: 11 }}>{item.getRealTimeAsia(0)}</font>
                                                <font style={{ color: '#878787', fontSize: 11 }}>{item.getRealTimeAsia(1)}</font>
                                                <font style={{ marginLeft: 8, color: '#0D0D0D', fontSize: 11 }}>{item.getRealTimeAsia(2)}</font>
                                            </font>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 2, 0, 2),
        border: 0,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        border: 0,
        height: 24,
    },
}))(MovieIndexRaqiu));